module.exports = __webpack_public_path__ + "static/img/join.caed5a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/BrandBk/join.png
// module id = 1117
// module chunks = 18